import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconThirdPartyErms = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M5.085 16.028a1.64 1.64 0 1 1-2.318-2.318 1.64 1.64 0 0 1 2.318 2.318M8.828 13.393h11.115c.393 0 .77.158 1.049.439a1.5 1.5 0 0 1 0 2.115c-.278.28-.656.438-1.05.438H8.829c-.394 0-.771-.157-1.05-.438a1.5 1.5 0 0 1 0-2.115c.279-.28.656-.439 1.05-.439M21.233 10.256a1.658 1.658 0 0 1-1.787.35c-.3-.122-.555-.33-.735-.596a1.6 1.6 0 0 1 0-1.799c.18-.266.436-.473.735-.596a1.66 1.66 0 0 1 1.787.35 1.62 1.62 0 0 1 .48 1.146 1.6 1.6 0 0 1-.48 1.144M4.057 7.615h11.115c.394 0 .771.155 1.05.432a1.47 1.47 0 0 1 0 2.086 1.5 1.5 0 0 1-1.05.433H4.057c-.393 0-.77-.156-1.049-.433a1.47 1.47 0 0 1 0-2.086 1.5 1.5 0 0 1 1.05-.432"
    />
  </NcIcon>
);
export { NcIconThirdPartyErms };
